<template>
  <div class="ac2" style="width: 100%">
    <nav-header></nav-header>
    <!-- banner -->
    <div class="banner" style="width: 100%">
      <img src="/imgs/info1.jpg" style="width: 100%" />
    </div>
    <!-- 顶宽布局 -->
    <div class="container">
      <!-- 标题 -->
      <div class="a2-title">
        <h3>关于我们</h3>
        <div class="blink"></div>
      </div>
      <!-- 容器 -->
      <div class="a2-con">
        <div class="a2-r"></div>
        <div class="a2-l">
          <div class="a2-box">
            <p>
             北京千鲤文化创意有限公司成立于2021年08月24日，注册地位于北京市朝阳区豆各庄黄厂西路1号A1栋二层25157，经营范围包括组织文化艺术交流活动（不含演出）；货物进出口、技术进出口、代理进出口；食品经营（仅销售预包装食品）；承办展览展示活动；设计、制作、代理、发布广告；电脑动画设计；企业策划；包装装潢设计；企业管理咨询；技术咨询、技术服务、技术转让；服装设计；产品设计；文艺创作；销售珠宝首饰、体育用品、工艺品、玩具、电子产品、花卉、树木（不含苗木）、针纺织品、服装、文具用品；出版物零售；互联网直播服务（不含新闻信息服务、网络表演、网络视听节目）；互联网信息服务；广播电视节目制作经营。（市场主体依法自主选择经营项目，开展经营活动；出版物零售、互联网直播服务（不含新闻信息服务、网络表演、网络视听节目）、互联网信息服务、广播电视节目制作经营以及依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事国家和本市产业政策禁止和限制类项目的经营活动。）
            </p>
            <p></p>
            <!-- <p>
              “敏学”用来称颂那些勤奋好学的人，一是敬佩他们渊博的学识；二是敬佩他们那种坚韧不拔、持之以恒的意志，这也正是敏学中蕴含的意义。
            </p> -->
          </div>
        </div>
      </div>
      <!-- 文本区 -->
      <div class="a2-info">
        <!-- 使命 -->
        <!-- <div class="a2-item">
          <h3>主营业务介绍:</h3>
          <p>
            （1）以智慧农业为载体的非单一学科的研究性学习基地/营地的运营、科技项目课程开发与运营，客户为3-16岁学生个体和幼儿园、小学及初中学校；
          </p>
          <p>
            （2）专注学生学业成绩的相关信息的数据工程、通过数据分析为客户提供决策支持；
          </p>
          <p>
            （3）面向有教育人口家庭的，聚焦于科学解决问题思想、工具和方法的课程内容开发。
          </p>
        </div> -->

        <!-- 价值观 -->
        <div class="a2-item">
          <h3>联系我们:</h3>
          <p>北京千鲤文化创意有限公司</p>
          <p>邮箱：aozirui@thefair.net.cn</p>
          <!-- <p>电话：010-62616733</p> -->
          <p>地址：北京市朝阳区豆各庄黄厂西路1号A1栋二层25157</p>
        </div>
      </div>
    </div>
    <nav-footer></nav-footer>
  </div>
</template>

<script>
import "swiper/css/swiper.css";
import NavFooter from "./../components/NavFooter";
import NavHeader from "./../components/NavHeader";
export default {
  name: "ac1",
  components: {
    NavFooter,
    NavHeader,
  },
  data() {
    return {};
  },
  mounted() {
    document.title = "北京千鲤文化创意有限公司";
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.ac2 {
  .banner {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
    margin-top: 80px;
  }
  .container {
    // height: 1000px;
    margin: 60px auto;
    padding-top: 30px;
    box-sizing: border-box;
    // 标题
    .a2-title {
      text-align: center;
      h3 {
        font-size: 21px;
        color: $colorZ;
      }
      .blink {
        width: 250px;
        height: 1px;
        background-color: $colorZ;
        margin: 5px auto;
      }
    }

    // 容器
    .a2-con {
      width: 100%;
      height: 500px;
      //   background-color: pink;
      box-sizing: border-box;
      @include flex();
      margin-top: 30px;
      // 左侧
      .a2-l {
        width: 50%;
        height: 100%;
        // background-color: red;
        position: relative;
        .a2-box {
          width: 80%;
          height: 80%;
          background-color: #4b80b7;
          position: absolute;
          left: 0;
          top: 50px;
          color: #fff;
          padding: 20px;
          box-sizing: border-box;
          p {
            font-size: 12px;
            // margin: 30px auto;
            line-height: 26px;
            text-indent: 30px;
          }
        }
      }
      // 右侧
      .a2-r {
        width: 50%;
        height: 100%;
        // background-color: yellow;
        background: url("/imgs/info2.jpg") no-repeat center;
        background-size: cover;
      }
    }
    // 文本区
    .a2-info {
      margin-top: 30px;
      .a2-item {
        margin-bottom: 60px;
        h3 {
          font-size: 24px;
          margin-bottom: 10px;
        }
        p {
          font-size: 14px;
          margin: 20px auto;
        }
      }
    }
  }
}
</style>
